export const SN_TRUSTPILOT = 'trustpilot'
export const SERVICE_INVITATION_URL = SN_TRUSTPILOT + '/SERVICE_INVITATION_URL'
